export const WEATHER_ICONS = {
  // Clear
  'clear sky': '☀️',
  'clear sky (night)': '🌙',
  'clear sky at night': '🌙',
  // Clouds
  'few clouds': '🌤️',
  'scattered clouds': '⛅',
  'broken clouds': '☁️',
  'overcast clouds': '☁️',
  // Rain
  'light rain': '🌦️',
  'moderate rain': '🌧️',
  'heavy intensity rain': '🌧️',
  'very heavy rain': '⛈️',
  'extreme rain': '⛈️',
  'freezing rain': '🌨️',
  'light intensity shower rain': '🌦️',
  'shower rain': '🌧️',
  'heavy intensity shower rain': '⛈️',
  'ragged shower rain': '⛈️',
  // Snow
  'light snow': '🌨️',
  'snow': '❄️',
  'heavy snow': '❄️',
  'sleet': '🌨️',
  'light shower sleet': '🌨️',
  'shower sleet': '🌨️',
  'light rain and snow': '🌨️',
  'rain and snow': '🌨️',
  'light shower snow': '🌨️',
  'shower snow': '🌨️',
  'heavy shower snow': '❄️',
  // Drizzle
  'light intensity drizzle': '🌦️',
  'drizzle': '🌦️',
  'heavy intensity drizzle': '🌧️',
  'light intensity drizzle rain': '🌦️',
  'drizzle rain': '🌧️',
  'heavy intensity drizzle rain': '🌧️',
  'shower rain and drizzle': '🌧️',
  'heavy shower rain and drizzle': '🌧️',
  'shower drizzle': '🌧️',
  // Thunderstorm
  'thunderstorm': '⛈️',
  'thunderstorm with light rain': '⛈️',
  'thunderstorm with rain': '⛈️',
  'thunderstorm with heavy rain': '⛈️',
  'light thunderstorm': '🌩️',
  'heavy thunderstorm': '⛈️',
  'ragged thunderstorm': '⛈️',
  'thunderstorm with light drizzle': '⛈️',
  'thunderstorm with drizzle': '⛈️',
  'thunderstorm with heavy drizzle': '⛈️',
  // Atmosphere
  'mist': '🌫️',
  'smoke': '🌫️',
  'haze': '🌫️',
  'sand/dust whirls': '🌪️',
  'fog': '🌫️',
  'sand': '🌪️',
  'dust': '🌫️',
  'volcanic ash': '🌋',
  'squalls': '🌪️',
  'tornado': '🌪️',
  // Default
  'default': '🌡️'
}; 